import styles from './product-filter.module.scss';
import { useCallback, useMemo, useState } from 'react';

const CaretIcon = () => {
  return (
    <svg
      x="0px"
      y="0px"
      width="11.41px"
      height="7.12px"
      fill="#bca169"
      viewBox="351.584 2118.292 11.848 6.338"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M363.311,2118.414c-0.164-0.163-0.429-0.163-0.592,0l-5.205,5.216l-5.215-5.216c-0.163-0.163-0.429-0.163-0.592,0s-0.163,0.429,0,0.592l5.501,5.501c0.082,0.082,0.184,0.123,0.296,0.123c0.103,0,0.215-0.041,0.296-0.123l5.501-5.501C363.474,2118.843,363.474,2118.577,363.311,2118.414L363.311,2118.414z"></path>
      </g>
    </svg>
  );
};

export const ProductsFilter = ({
  filters = [],
  activeFilters = {},
  allowedFilters,
  displayFiltersMobile,
  onCloseMobileFilters,
  onChangeFilter,
}) => {
  const [expandedSections, setExpandedSections] = useState([]);

  const handleToggleSection = useCallback(
    sectionField => {
      if (expandedSections.includes(sectionField)) {
        setExpandedSections(expandedSections.filter(field => field !== sectionField));
      } else {
        setExpandedSections([...expandedSections, sectionField]);
      }
    },
    [expandedSections, setExpandedSections]
  );

  const handleToggleFilterItem = useCallback(
    (categoryField, itemId) => {
      let filters = activeFilters;
      if (activeFilters[categoryField]?.includes(itemId)) {
        filters = {
          ...filters,
          [categoryField]: filters[categoryField].filter(_itemId => _itemId !== itemId),
        };
      } else {
        filters = {
          ...filters,
          [categoryField]: [...(filters[categoryField] || []), itemId],
        };
      }
      onChangeFilter(filters);
    },
    [activeFilters, onChangeFilter]
  );

  const wrapperClassName = useMemo(() => {
    const base = [styles.wrapper];
    if (displayFiltersMobile) {
      base.push(styles.wrapperMobile);
    }
    return base.join(' ');
  }, [displayFiltersMobile]);

  return (
    <div className={wrapperClassName}>
      <div className={styles.wrapperMobileHeader}>
        <svg
          onClick={onCloseMobileFilters}
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5001 0L5.99947 4.5L1.49987 0L0 1.5L4.4996 6L0 10.5L1.49987 12L5.99947 7.5L10.5001 12L12 10.5L7.5004 6L12 1.5L10.5001 0Z"
            fill="white"
          />
        </svg>
      </div>
      {filters.map(filter => (
        <div key={filter.field} className={'filter__section'}>
          <span
            onClick={() => handleToggleSection(filter.field)}
            className={styles.filterSectionHeader}
          >
            {filter.title} <CaretIcon />
          </span>
          {expandedSections.includes(filter.field) &&
            filter.values.map(filterValue => {
              let disabled = false;
              const classNames = activeFilters[filter.field]?.includes(filterValue.id)
                ? [styles.filterSectionItem, styles.filterChecked]
                : [styles.filterSectionItem];
              if (!allowedFilters[filter.field].includes(filterValue.id)) {
                classNames.push(styles.filterSectionItemDisabled);
                disabled = true;
              }
              return (
                <span
                  onClick={() => !disabled && handleToggleFilterItem(filter.field, filterValue?.id)}
                  key={filterValue.id}
                  className={classNames.join(' ')}
                >
                  <span>{filterValue.title}</span>
                </span>
              );
            })}
        </div>
      ))}
    </div>
  );
};
